import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AgentDashboard } from '../components/AgentDashboard';
import { useAuth } from '../hooks/useAuth';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Bot, Sparkles, Loader2 } from 'lucide-react';

const Index = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) {
      navigate('/auth');
    }
  }, [user, loading, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-background via-background/50 to-primary/10 flex items-center justify-center">
        <Card className="p-8 border-0 shadow-xl bg-card/80 backdrop-blur-sm">
          <CardContent className="flex flex-col items-center gap-4">
            <div className="flex items-center gap-2">
              <Bot className="h-8 w-8 text-primary" />
              <Sparkles className="h-6 w-6 text-primary" />
            </div>
            <Loader2 className="h-6 w-6 animate-spin text-primary" />
            <p className="text-muted-foreground">Loading your AI workspace...</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-background via-background/50 to-primary/10 flex items-center justify-center p-4">
        <Card className="max-w-md w-full border-0 shadow-xl bg-card/80 backdrop-blur-sm">
          <CardContent className="p-8 text-center">
            <div className="flex items-center justify-center gap-2 mb-6">
              <Bot className="h-8 w-8 text-primary" />
              <Sparkles className="h-6 w-6 text-primary" />
            </div>
            <h1 className="text-2xl font-bold mb-2">Welcome to AI Agent Hub</h1>
            <p className="text-muted-foreground mb-6">
              Please sign in to access your AI agent management dashboard
            </p>
            <Button onClick={() => navigate('/auth')} className="w-full">
              Sign In
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <AgentDashboard />;
};

export default Index;